var isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
        );
    },
};
$(document).ready(function () {
    if (isMobile.any()) {
        $('.nav-list-level-1-item .js-dropdown-click').each(function () {
            $(this).removeAttr('href');
        });
    }
});

/*! waitForImages jQuery Plugin 2018-02-13 */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){var b="waitForImages",c=function(a){return a.srcset&&a.sizes}(new Image);a.waitForImages={hasImageProperties:["backgroundImage","listStyleImage","borderImage","borderCornerImage","cursor"],hasImageAttributes:["srcset"]},a.expr.pseudos["has-src"]=function(b){return a(b).is('img[src][src!=""]')},a.expr.pseudos.uncached=function(b){return!!a(b).is(":has-src")&&!b.complete},a.fn.waitForImages=function(){var d,e,f,g=0,h=0,i=a.Deferred(),j=this,k=[],l=a.waitForImages.hasImageProperties||[],m=a.waitForImages.hasImageAttributes||[],n=/url\(\s*(['"]?)(.*?)\1\s*\)/g;if(a.isPlainObject(arguments[0])?(f=arguments[0].waitForAll,e=arguments[0].each,d=arguments[0].finished):1===arguments.length&&"boolean"===a.type(arguments[0])?f=arguments[0]:(d=arguments[0],e=arguments[1],f=arguments[2]),d=d||a.noop,e=e||a.noop,f=!!f,!a.isFunction(d)||!a.isFunction(e))throw new TypeError("An invalid callback was supplied.");return this.each(function(){var b=a(this);f?b.find("*").addBack().each(function(){var b=a(this);b.is("img:has-src")&&!b.is("[srcset]")&&k.push({src:b.attr("src"),element:b[0]}),a.each(l,function(a,c){var d,e=b.css(c);if(!e)return!0;for(;d=n.exec(e);)k.push({src:d[2],element:b[0]})}),a.each(m,function(a,c){var d=b.attr(c);return!d||void k.push({src:b.attr("src"),srcset:b.attr("srcset"),element:b[0]})})}):b.find("img:has-src").each(function(){k.push({src:this.src,element:this})})}),g=k.length,h=0,0===g&&(d.call(j),i.resolveWith(j)),a.each(k,function(f,k){var l=new Image,m="load."+b+" error."+b;a(l).one(m,function b(c){var f=[h,g,"load"==c.type];if(h++,e.apply(k.element,f),i.notifyWith(k.element,f),a(this).off(m,b),h==g)return d.call(j[0]),i.resolveWith(j[0]),!1}),c&&k.srcset&&(l.srcset=k.srcset,l.sizes=k.sizes),l.src=k.src}),i.promise()}});


(function (factory) {
    var registeredInModuleLoader = !1;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = !0;
    }
    if (typeof exports === 'object') {
        module.exports = factory();
        registeredInModuleLoader = !0;
    }
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = (window.Cookies = factory());
        api.noConflict = function () {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function () {
    function extend() {
        var i = 0;
        var result = {};
        for (; i < arguments.length; i++) {
            var attributes = arguments[i];
            for (var key in attributes) {
                result[key] = attributes[key];
            }
        }
        return result;
    }
    function init(converter) {
        function api(key, value, attributes) {
            var result;
            if (typeof document === 'undefined') {
                return;
            }
            if (arguments.length > 1) {
                attributes = extend({ path: '/' }, api.defaults, attributes);
                if (typeof attributes.expires === 'number') {
                    var expires = new Date();
                    expires.setMilliseconds(
                        expires.getMilliseconds() + attributes.expires * 864e5,
                    );
                    attributes.expires = expires;
                }
                attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
                try {
                    result = JSON.stringify(value);
                    if (/^[\{\[]/.test(result)) {
                        value = result;
                    }
                } catch (e) {}
                if (!converter.write) {
                    value = encodeURIComponent(String(value)).replace(
                        /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                        decodeURIComponent,
                    );
                } else {
                    value = converter.write(value, key);
                }
                key = encodeURIComponent(String(key));
                key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
                key = key.replace(/[\(\)]/g, escape);
                var stringifiedAttributes = '';
                for (var attributeName in attributes) {
                    if (!attributes[attributeName]) {
                        continue;
                    }
                    stringifiedAttributes += '; ' + attributeName;
                    if (attributes[attributeName] === !0) {
                        continue;
                    }
                    stringifiedAttributes += '=' + attributes[attributeName];
                }
                return (document.cookie = key + '=' + value + stringifiedAttributes);
            }
            if (!key) {
                result = {};
            }
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var rdecode = /(%[0-9A-Z]{2})+/g;
            var i = 0;
            for (; i < cookies.length; i++) {
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (cookie.charAt(0) === '"') {
                    cookie = cookie.slice(1, -1);
                }
                try {
                    var name = parts[0].replace(rdecode, decodeURIComponent);
                    cookie = converter.read
                        ? converter.read(cookie, name)
                        : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);
                    if (this.json) {
                        try {
                            cookie = JSON.parse(cookie);
                        } catch (e) {}
                    }
                    if (key === name) {
                        result = cookie;
                        break;
                    }
                    if (!key) {
                        result[name] = cookie;
                    }
                } catch (e) {}
            }
            return result;
        }
        api.set = api;
        api.get = function (key) {
            return api.call(api, key);
        };
        api.getJSON = function () {
            return api.apply({ json: !0 }, [].slice.call(arguments));
        };
        api.defaults = {};
        api.remove = function (key, attributes) {
            api(key, '', extend(attributes, { expires: -1 }));
        };
        api.withConverter = init;
        return api;
    }
    return init(function () {});
});

!(function (t, e) {
    'use strict';
    function r(r, a, i, u, l) {
        function f() {
            (L = t.devicePixelRatio > 1),
                (i = c(i)),
                a.delay >= 0 &&
                    setTimeout(function () {
                        s(!0);
                    }, a.delay),
                (a.delay < 0 || a.combined) &&
                    ((u.e = v(a.throttle, function (t) {
                        'resize' === t.type && (w = B = -1), s(t.all);
                    })),
                    (u.a = function (t) {
                        (t = c(t)), i.push.apply(i, t);
                    }),
                    (u.g = function () {
                        return (i = n(i).filter(function () {
                            return !n(this).data(a.loadedName);
                        }));
                    }),
                    (u.f = function (t) {
                        for (var e = 0; e < t.length; e++) {
                            var r = i.filter(function () {
                                return this === t[e];
                            });
                            r.length && s(!1, r);
                        }
                    }),
                    s(),
                    n(a.appendScroll).on('scroll.' + l + ' resize.' + l, u.e));
        }
        function c(t) {
            var i = a.defaultImage,
                o = a.placeholder,
                u = a.imageBase,
                l = a.srcsetAttribute,
                f = a.loaderAttribute,
                c = a._f || {};
            t = n(t)
                .filter(function () {
                    var t = n(this),
                        r = m(this);
                    return (
                        !t.data(a.handledName) &&
                        (t.attr(a.attribute) || t.attr(l) || t.attr(f) || c[r] !== e)
                    );
                })
                .data('plugin_' + a.name, r);
            for (var s = 0, d = t.length; s < d; s++) {
                var A = n(t[s]),
                    g = m(t[s]),
                    h = A.attr(a.imageBaseAttribute) || u;
                g === N && h && A.attr(l) && A.attr(l, b(A.attr(l), h)),
                    c[g] === e || A.attr(f) || A.attr(f, c[g]),
                    g === N && i && !A.attr(E)
                        ? A.attr(E, i)
                        : g === N ||
                          !o ||
                          (A.css(O) && 'none' !== A.css(O)) ||
                          A.css(O, "url('" + o + "')");
            }
            return t;
        }
        function s(t, e) {
            if (!i.length) return void (a.autoDestroy && r.destroy());
            for (
                var o = e || i,
                    u = !1,
                    l = a.imageBase || '',
                    f = a.srcsetAttribute,
                    c = a.handledName,
                    s = 0;
                s < o.length;
                s++
            )
                if (t || e || A(o[s])) {
                    var g = n(o[s]),
                        h = m(o[s]),
                        b = g.attr(a.attribute),
                        v = g.attr(a.imageBaseAttribute) || l,
                        p = g.attr(a.loaderAttribute);
                    g.data(c) ||
                        (a.visibleOnly && !g.is(':visible')) ||
                        !(
                            ((b || g.attr(f)) &&
                                ((h === N && (v + b !== g.attr(E) || g.attr(f) !== g.attr(F))) ||
                                    (h !== N && v + b !== g.css(O)))) ||
                            p
                        ) ||
                        ((u = !0), g.data(c, !0), d(g, h, v, p));
                }
            u &&
                (i = n(i).filter(function () {
                    return !n(this).data(c);
                }));
        }
        function d(t, e, r, i) {
            ++z;
            var o = function () {
                y('onError', t), p(), (o = n.noop);
            };
            y('beforeLoad', t);
            var u = a.attribute,
                l = a.srcsetAttribute,
                f = a.sizesAttribute,
                c = a.retinaAttribute,
                s = a.removeAttribute,
                d = a.loadedName,
                A = t.attr(c);
            if (i) {
                var g = function () {
                    s && t.removeAttr(a.loaderAttribute),
                        t.data(d, !0),
                        y(T, t),
                        setTimeout(p, 1),
                        (g = n.noop);
                };
                t.off(I).one(I, o).one(D, g),
                    y(i, t, function (e) {
                        e ? (t.off(D), g()) : (t.off(I), o());
                    }) || t.trigger(I);
            } else {
                var h = n(new Image());
                h.one(I, o).one(D, function () {
                    t.hide(),
                        e === N
                            ? t.attr(C, h.attr(C)).attr(F, h.attr(F)).attr(E, h.attr(E))
                            : t.css(O, "url('" + h.attr(E) + "')"),
                        t[a.effect](a.effectTime),
                        s &&
                            (t.removeAttr(u + ' ' + l + ' ' + c + ' ' + a.imageBaseAttribute),
                            f !== C && t.removeAttr(f)),
                        t.data(d, !0),
                        y(T, t),
                        h.remove(),
                        p();
                });
                var m = (L && A ? A : t.attr(u)) || '';
                h
                    .attr(C, t.attr(f))
                    .attr(F, t.attr(l))
                    .attr(E, m ? r + m : null),
                    h.complete && h.trigger(D);
            }
        }
        function A(t) {
            var e = t.getBoundingClientRect(),
                r = a.scrollDirection,
                n = a.threshold,
                i = h() + n > e.top && -n < e.bottom,
                o = g() + n > e.left && -n < e.right;
            return 'vertical' === r ? i : 'horizontal' === r ? o : i && o;
        }
        function g() {
            return w >= 0 ? w : (w = n(t).width());
        }
        function h() {
            return B >= 0 ? B : (B = n(t).height());
        }
        function m(t) {
            return t.tagName.toLowerCase();
        }
        function b(t, e) {
            if (e) {
                var r = t.split(',');
                t = '';
                for (var a = 0, n = r.length; a < n; a++)
                    t += e + r[a].trim() + (a !== n - 1 ? ',' : '');
            }
            return t;
        }
        function v(t, e) {
            var n,
                i = 0;
            return function (o, u) {
                function l() {
                    (i = +new Date()), e.call(r, o);
                }
                var f = +new Date() - i;
                n && clearTimeout(n),
                    f > t || !a.enableThrottle || u ? l() : (n = setTimeout(l, t - f));
            };
        }
        function p() {
            --z, i.length || z || y('onFinishedAll');
        }
        function y(t, e, n) {
            return !!(t = a[t]) && (t.apply(r, [].slice.call(arguments, 1)), !0);
        }
        var z = 0,
            w = -1,
            B = -1,
            L = !1,
            T = 'afterLoad',
            D = 'load',
            I = 'error',
            N = 'img',
            E = 'src',
            F = 'srcset',
            C = 'sizes',
            O = 'background-image';
        'event' === a.bind || o ? f() : n(t).on(D + '.' + l, f);
    }
    function a(a, o) {
        var u = this,
            l = n.extend({}, u.config, o),
            f = {},
            c = l.name + '-' + ++i;
        return (
            (u.config = function (t, r) {
                return r === e ? l[t] : ((l[t] = r), u);
            }),
            (u.addItems = function (t) {
                return f.a && f.a('string' === n.type(t) ? n(t) : t), u;
            }),
            (u.getItems = function () {
                return f.g ? f.g() : {};
            }),
            (u.update = function (t) {
                return f.e && f.e({}, !t), u;
            }),
            (u.force = function (t) {
                return f.f && f.f('string' === n.type(t) ? n(t) : t), u;
            }),
            (u.loadAll = function () {
                return f.e && f.e({ all: !0 }, !0), u;
            }),
            (u.destroy = function () {
                return n(l.appendScroll).off('.' + c, f.e), n(t).off('.' + c), (f = {}), e;
            }),
            r(u, l, a, f, c),
            l.chainable ? a : u
        );
    }
    var n = t.jQuery || t.Zepto,
        i = 0,
        o = !1;
    (n.fn.Lazy = n.fn.lazy =
        function (t) {
            return new a(this, t);
        }),
        (n.Lazy = n.lazy =
            function (t, r, i) {
                if ((n.isFunction(r) && ((i = r), (r = [])), n.isFunction(i))) {
                    (t = n.isArray(t) ? t : [t]), (r = n.isArray(r) ? r : [r]);
                    for (
                        var o = a.prototype.config, u = o._f || (o._f = {}), l = 0, f = t.length;
                        l < f;
                        l++
                    )
                        (o[t[l]] === e || n.isFunction(o[t[l]])) && (o[t[l]] = i);
                    for (var c = 0, s = r.length; c < s; c++) u[r[c]] = t[0];
                }
            }),
        (a.prototype.config = {
            name: 'lazy',
            chainable: !0,
            autoDestroy: !0,
            bind: 'load',
            threshold: 500,
            visibleOnly: !1,
            appendScroll: t,
            scrollDirection: 'both',
            imageBase: null,
            defaultImage:
                'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
            placeholder: null,
            delay: -1,
            combined: !1,
            attribute: 'data-src',
            srcsetAttribute: 'data-srcset',
            sizesAttribute: 'data-sizes',
            retinaAttribute: 'data-retina',
            loaderAttribute: 'data-loader',
            imageBaseAttribute: 'data-imagebase',
            removeAttribute: !0,
            handledName: 'handled',
            loadedName: 'loaded',
            effect: 'show',
            effectTime: 0,
            enableThrottle: !0,
            throttle: 250,
            beforeLoad: e,
            afterLoad: e,
            onError: e,
            onFinishedAll: e,
        }),
        n(t).on('load', function () {
            o = !0;
        });
})(window);



$(document).ready(function () {
    ///////////////////////////////////////////////////////////////////////////////
    //////// Short period where page is hidden to provide time for element shifts to
    //////// load.
    ///////////////////////////////////////////////////////////////////////////////
    setTimeout(function () {
        $('body').removeClass('body--hidden');
    }, 0070);

    $('.js-wait-for-image').waitForImages(function () {
        $('.hidden-before-images-ready').animate({ opacity: '1' }, 200);
    });

    

    if ($('html.mod-no-mobile').length) {
        $('.js-dropdown-hover').hover(
            function () {
                $(this).addClass('open');
            },
            function () {
                $(this).removeClass('open');
            },
        );
        $(document).on('mouseenter', '.js-dropdown-hover', function () {
            $(this).addClass('open');
        });
        $(document).on('mouseleave', '.js-dropdown-hover', function () {
            $(this).removeClass('open');
        });
    }
    if ($('html.mod-mobile').length) {
        $(document).on('click', '.js-dropdown-toggle', function () {
            var $dropdown = $(this).parent();
            $dropdown.siblings().removeClass('open');
            setTimeout(function () {
                $dropdown.toggleClass('open');
            }, 355);
        });
    }

    

    var is_iPad = navigator.userAgent.match(/iPad/i) != null;

    if (is_iPad) {
        $('body').addClass('device-is-ipad');
    }

    var isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;

    

    // function check() {
    //   var $box = $(".desktop-navbar-banner, .mobile-navbar-banner");
    //   $box.find(".close-desktop-navbar-banner").click(function () {
    //     $box.addClass("close-top-banner");
    //     Cookies.set("krw_marketing_top_bar_test1", "true", { expires: 1 });
    //     $("body").addClass("normal-body-top-spacing");
    //     $("body").removeClass("banner-enable");
    //   });
    // };

    ///////////////////////////////////////////////////////////////////////////////
    //////// Initiate lazyload for images
    ///////////////////////////////////////////////////////////////////////////////

    $('.lazy').lazy({ effect: 'fadeIn', effectTime: 0100, threshold: 700 });

    if ($(window).width() > 835) {
        $('.desktop-lazy').lazy({ effect: 'fadeIn', effectTime: 0100, threshold: 400 });
    } else {
        $('.mobile-lazy').lazy({ effect: 'fadeIn', effectTime: 0100, threshold: 400 });
    }

    ///////////////////////////////////////////////////////////////////////////////
    //////// Load image based on device size
    ///////////////////////////////////////////////////////////////////////////////
    function initImageSrc() {
        var imageBgs = document.querySelectorAll('[data-bg]');
        var screenWidth = window.innerWidth;
        var imageBgsMain = document.querySelectorAll('#shopify-section-1508967056478 [data-bg]');
        for (var i = 0; i < imageBgsMain.length; i++) {
            if (screenWidth < 768) {
                $('.product-card-secondary-image').remove();
                imageBgsMain[i].style.backgroundImage =
                    'url(' + imageBgsMain[i].getAttribute('data-img-mobile') + ')';
            } else if (
                (screenWidth >= 768 && screenWidth <= 1024) ||
                (screenWidth > 1024 && isMobile.any())
            ) {
                imageBgsMain[i].style.backgroundImage =
                    'url(' + imageBgsMain[i].getAttribute('data-img-tablet') + ')';
            } else if (screenWidth > 1024 && screenWidth <= 1366) {
                imageBgsMain[i].style.backgroundImage =
                    'url(' + imageBgsMain[i].getAttribute('data-img-desktop') + ')';
            } else {
                imageBgsMain[i].style.backgroundImage =
                    'url(' + imageBgsMain[i].getAttribute('data-img-jumbo') + ')';
            }
        }
        for (var i = 0; i < imageBgs.length; i++) {
            if (screenWidth < 768) {
                $('.product-card-secondary-image').remove();
                imageBgs[i].style.backgroundImage =
                    'url(' + imageBgs[i].getAttribute('data-img-mobile') + ')';
            } else if (
                $(window).width() == 1024 &&
                $(window).innerHeight() <= 1366 &&
                $(window).innerHeight() > 800
            ) {
                imageBgs[i].style.backgroundImage =
                    'url(' + imageBgs[i].getAttribute('data-img-ipad-pro') + ')';
            } else if (
                (screenWidth >= 768 && screenWidth <= 1024) ||
                (screenWidth > 1024 && isMobile.any())
            ) {
                imageBgs[i].style.backgroundImage =
                    'url(' + imageBgs[i].getAttribute('data-img-tablet') + ')';
            } else if (screenWidth > 1024 && screenWidth <= 1366) {
                imageBgs[i].style.backgroundImage =
                    'url(' + imageBgs[i].getAttribute('data-img-desktop') + ')';
            } else {
                imageBgs[i].style.backgroundImage =
                    'url(' + imageBgs[i].getAttribute('data-img-jumbo') + ')';
            }
        }
        $(window).on('resize scroll', function () {
            if (screenWidth < 768) {
                $(window).bind('load', function () {
                    var videoURL = $('.mobile-hp-section .hp-editorial-video source').attr(
                        'data-mobile-video',
                    );
                    $('.mobile-hp-section .hp-editorial-video source').attr('src', videoURL);
                });
            }
            for (var i = 0; i < imageBgs.length; i++) {
                if (screenWidth < 768) {
                    $('.product-card-secondary-image').remove();
                    imageBgs[i].style.backgroundImage =
                        'url(' + imageBgs[i].getAttribute('data-img-mobile') + ')';
                } else if (
                    $(window).width() == 1024 &&
                    $(window).innerHeight() <= 1366 &&
                    $(window).innerHeight() > 800
                ) {
                    imageBgs[i].style.backgroundImage =
                        'url(' + imageBgs[i].getAttribute('data-img-ipad-pro') + ')';
                } else if (
                    (screenWidth >= 768 && screenWidth <= 1024) ||
                    (screenWidth > 1024 && isMobile.any())
                ) {
                    imageBgs[i].style.backgroundImage =
                        'url(' + imageBgs[i].getAttribute('data-img-tablet') + ')';
                } else if (screenWidth > 1024 && screenWidth <= 1366) {
                    imageBgs[i].style.backgroundImage =
                        'url(' + imageBgs[i].getAttribute('data-img-desktop') + ')';
                } else {
                    imageBgs[i].style.backgroundImage =
                        'url(' + imageBgs[i].getAttribute('data-img-jumbo') + ')';
                }
            }
        });
        window.onresize = function () {
            var resizedScreenWidth = window.innerWidth;
            for (var i = 0; i < imageBgs.length; i++) {
                if (resizedScreenWidth < 768) {
                    $('.product-card-secondary-image').remove();
                    imageBgs[i].style.backgroundImage =
                        'url(' + imageBgs[i].getAttribute('data-img-mobile') + ')';
                } else if (
                    $(window).width() == 1024 &&
                    $(window).innerHeight() <= 1366 &&
                    $(window).innerHeight() > 800
                ) {
                    imageBgs[i].style.backgroundImage =
                        'url(' + imageBgs[i].getAttribute('data-img-ipad-pro') + ')';
                } else if (
                    (resizedScreenWidth >= 768 && resizedScreenWidth <= 1024) ||
                    (screenWidth > 1024 && isMobile.any())
                ) {
                    imageBgs[i].style.backgroundImage =
                        'url(' + imageBgs[i].getAttribute('data-img-tablet') + ')';
                } else if (resizedScreenWidth > 1024 && resizedScreenWidth <= 1366) {
                    imageBgs[i].style.backgroundImage =
                        'url(' + imageBgs[i].getAttribute('data-img-desktop') + ')';
                } else {
                    imageBgs[i].style.backgroundImage =
                        'url(' + imageBgs[i].getAttribute('data-img-jumbo') + ')';
                }
            }
        };
        var imageBgs2 = $('.main-image');
        var screenWidth = window.innerWidth;
        for (var i = 0; i < imageBgs2.length; i++) {
            if (screenWidth < 768) {
                $('.product-card-secondary-image').remove();
                imageBgs2[i].style.backgroundImage =
                    'url(' + imageBgs2[i].getAttribute('data-img-mobile') + ')';
            } else if (
                (screenWidth >= 768 && screenWidth <= 1024) ||
                (screenWidth > 1024 && isMobile.any())
            ) {
                imageBgs2[i].style.backgroundImage =
                    'url(' + imageBgs2[i].getAttribute('data-img-tablet') + ')';
            } else if (screenWidth > 1024 && screenWidth <= 1366) {
                imageBgs2[i].style.backgroundImage =
                    'url(' + imageBgs2[i].getAttribute('data-img-desktop') + ')';
            } else {
                imageBgs2[i].style.backgroundImage =
                    'url(' + imageBgs2[i].getAttribute('data-img-jumbo') + ')';
            }
        }
        $(
            '.related-products .product-image-color-overlay,.template-index .product-image-color-overlay, .template-collection-edits .product-image-color-overlay, .template-collection .product-image-color-overlay, .template-collection-active .product-image-color-overlay, .template-page-active-landing .product-image-color-overlay, .template-page-spaces .product-image-color-overlay, .template-collection-lite .product-image-color-overlay, .desktop-navbar .product-image-color-overlay, .hp-products-grid.grid.grid-uniform.hp-pillar .product-image-color-overlay, .js-product-card-option-value',
        ).on('mouseenter', function () {
            var imageBgsSecondaryCollection = $(this)
                .parents('.product-card, .variant-card-deluxe')
                .find('.product-card-image:not(:first)');
            for (var i = 0; i < imageBgsSecondaryCollection.length; i++) {
                if (screenWidth < 768) {
                    $('.product-card-secondary-image').remove();
                    imageBgsSecondaryCollection[i].style.backgroundImage =
                        'url(' +
                        imageBgsSecondaryCollection[i].getAttribute('data-img-mobile') +
                        ')';
                } else if (
                    (screenWidth >= 768 && screenWidth <= 1024) ||
                    (screenWidth > 1024 && isMobile.any())
                ) {
                    imageBgsSecondaryCollection[i].style.backgroundImage =
                        'url(' +
                        imageBgsSecondaryCollection[i].getAttribute('data-img-tablet') +
                        ')';
                } else if (screenWidth > 1024 && screenWidth <= 1366) {
                    imageBgsSecondaryCollection[i].style.backgroundImage =
                        'url(' +
                        imageBgsSecondaryCollection[i].getAttribute('data-img-desktop') +
                        ')';
                } else {
                    imageBgsSecondaryCollection[i].style.backgroundImage =
                        'url(' +
                        imageBgsSecondaryCollection[i].getAttribute('data-img-jumbo') +
                        ')';
                }
            }
        });
    }

    initImageSrc();

    ///////////////////////////////////////////////////////////////////////////////
    //////// Hover carousel on image tiles
    ///////////////////////////////////////////////////////////////////////////////
    var Image = {
        init: function () {
            Image.setupImages();
            Image.bindEvents();
        },
        bindEvents: function () {
            $('.product-card-canvas').each(function () {
                var hovered = $(this);
                var cycle;
                var timer;
                hovered.hover(
                    function () {
                        var thumbnailIndex = 0;
                        var thumbnailArray = hovered
                            .children()
                            .not('.product-image-color-overlay');
                        timer = setTimeout(function () {
                            thumbnailIndex++;
                            var $visible = thumbnailArray.eq(thumbnailIndex);
                            thumbnailArray.removeClass('image-active');
                            $visible.addClass('image-active');
                            cycle = setInterval(function () {
                                thumbnailIndex++;
                                if (thumbnailIndex === thumbnailArray.length) {
                                    thumbnailIndex = 0;
                                    thumbnailArray.removeClass('image-active');
                                    thumbnailArray.eq(0).addClass('image-active');
                                } else {
                                    var $visible = thumbnailArray.eq(thumbnailIndex);
                                    thumbnailArray.removeClass('image-active');
                                    $visible.addClass('image-active');
                                }
                            }, 1800);
                        }, 1300);
                    },
                    function () {
                        var thumbnailArray = hovered
                            .children()
                            .not('.product-image-color-overlay');
                        thumbnailArray.removeClass('image-active');
                        thumbnailArray.eq(0).addClass('image-active');
                        clearTimeout(timer);
                        clearInterval(cycle);
                    },
                );
            });
        },
        setupImages: function () {
            var projectImage = $(
                '.collection-container .product-card-canvas, .search-bar-item .product-card-canvas',
            );
            projectImage.each(function () {
                $(this).find('.product-card-image:eq(0)').addClass('image-active');
            });
            var projectHomeImage = $(
                '.hp-products-grid.grid.grid-uniform.hp-pillar .product-card-canvas',
            );
            projectHomeImage.each(function () {
                $(this).find('.product-card-image:eq(0)').addClass('image-active');
            });
            $('li.nav-list-level-1-item.desktop-navbar-nav-dropdown.dropdown').on(
                'mouseenter',
                function () {
                    var projectImage1 = $(
                        '.desktop-navbar-nav-dropdown-menu.dropdown-menu .product-card-canvas',
                    );
                    projectImage1.each(function () {
                        $(this).find('.product-card-image:eq(0)').addClass('image-active');
                    });
                },
            );
            $('.desktop-navbar').on('mouseleave', function () {
                var projectImage2 = $(
                    '.desktop-navbar-nav-dropdown-menu.dropdown-menu .product-card-canvas, .search-bar-result .product-card-canvas',
                );
                projectImage2.each(function () {
                    $(this).find('.product-card-image:eq(0)').removeClass('image-active');
                });
            });
        },
    };

    ///////////////////////////////////////////////////////////////////////////////
    //////// Check if mobile Safari
    ///////////////////////////////////////////////////////////////////////////////
    Modernizr.addTest('mobile-safari', function () {
        return /iP(ad|hone|od).+Version\/[\d\.]+.*Safari/i.test(navigator.userAgent);
    });

    $.urlParam = function (name) {
        var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href);
        return results || 0;
    };

    ///////////////////////////////////////////////////////////////////////////////
  //////// Main UI button click events
  ///////////////////////////////////////////////////////////////////////////////
  $(document).on("click", ".js-body-add-class", function () {
    $("body").addClass($(this).data("body-class"));
  });

  $(document).on("click", ".js-body-remove-class", function () {
    $("body").removeClass($(this).data("body-class"));
  });

  $(document).on("click", ".js-body-toggle-class", function () {
    $("body").toggleClass($(this).data("body-class"));
  });

  $(document).on("click", ".js-element-fadein", function () {
    $($(this).data("element-selector")).fadeIn(400);
  });

  $(document).on("click", ".js-element-fadeout", function () {
    $($(this).data("element-selector")).fadeOut(400);
  });

  $(document).on("click", ".js-element-toggle", function () {
    $($(this).data("element-selector")).fadeToggle(400);
  });
  
  $(document).on("click", ".js-element-fadeinout", function () {
    var $this = $(this);
    $($this.data("in-element-selector")).show();
    $($this.data("out-element-selector")).hide();
  });

  $(document).on("click", ".js-body-scroll-to-element", function (event) {
    var elementSelector = $(this).data("element-selector");
    var scrollOffset = $(".desktop-navbar-nav").height() + $(".page-breadcrumb").height();
    $("html, body").animate({ scrollTop: $(elementSelector).offset().top - scrollOffset }, 600, "easeOutExpo");
  });

  $(document).on("click", ".js-element-slideupdown", function () {
    var $this = $(this);
    var index = $this.index();
    var $switchTargets = $($this.data("element-selector"));
    var $activeTarget = $switchTargets.filter(":visible");
    $this.addClass("active").siblings().removeClass("active");
    if ($activeTarget.length) {
      $activeTarget.slideUp(300, function () {
        $switchTargets.eq(index).slideDown(300);
      });
    } else {
      $switchTargets.eq(index).slideDown(300);
    }
  });
  
  $(document).on("click", ".js-stop-propagation", function (event) {
    event.stopPropagation();
  });

    
    $(document).on('click', '.tab-label', function (event) {
        event.preventDefault();
        var $this = $(this);
        var index = $this.index();
        var $tabContent = $this.parents('.tab').find('.tab-content');
        $this.addClass('active').siblings().removeClass('active');
        $tabContent.filter(':visible').fadeOut(0, function () {
            $tabContent.eq(index).fadeIn(0);
        });
    });

    function removeClassWithPrefix(element, classPrefix) {
        var regex = new RegExp('(^|\\s)' + classPrefix + '\\S+', 'g');
        element.removeClass(function (index, css) {
            return (css.match(regex) || []).join(' ');
        });
    }


    ///////////////////////////////////////////////////////////////////////////////
    //////// OwlCarousel arrows
    ///////////////////////////////////////////////////////////////////////////////
    $('.owl-carousel-nav-prev').click(function () {
        $(this)
            .parents('.owl-carousel-wrapper')
            .find('.owl-carousel')
            .trigger('prev.owl.carousel');
    });
    $('.owl-carousel-nav-next').click(function () {
        $(this)
            .parents('.owl-carousel-wrapper')
            .find('.owl-carousel')
            .trigger('next.owl.carousel');
    });


    ///////////////////////////////////////////////////////////////////////////////
    //////// Stockists Page
    ///////////////////////////////////////////////////////////////////////////////

    if ($('.template-page-stockists').length) {
        setTimeout(function () {
            $('#storepoint-panel').prepend($('#storepoint-search'));
        }, 2000);
    }

    ///////////////////////////////////////////////////////////////////////////////
    //////// Check if browsing from Instagram in-app browser
    ///////////////////////////////////////////////////////////////////////////////
    setTimeout(function () {
        var isInstagram = navigator.userAgent.match(/instagram/i);
        if (isInstagram) {
            $('body').addClass('instagram-browser');
        }
    }, 1000);

    // Browser detection
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        $('body').addClass('safari--browser');
    }

    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var deltaDown = 5;
    var deltaUp = 250;

    $(window).scroll(function () {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop();

        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= deltaDown) return;

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop) {
            // Scroll Down
            $('body').removeClass('nav-down').addClass('nav-up');
        } else {
            // Scroll Up

            if (st + $(window).height() < $(document).height()) {
                if (Math.abs(lastScrollTop - st) >= deltaUp) {
                    $('body').removeClass('nav-up').addClass('nav-down');
                }
            }
        }

        lastScrollTop = st;
    }

    var is_iPad = navigator.userAgent.match(/iPad/i) != null;

    if (is_iPad) {
        $('body').addClass('device-is-ipad');
    }

    $.fn.isInViewportDeals = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    };


    $(document).on('click', '.js-reset-password-fadein', function () {
        $('.recover-password-form').fadeIn(0);
        $('.customer-login-form').fadeOut(0);
    });
    $(document).on('click', '.js-rest-password-fadeout', function () {
        $('.recover-password-form').fadeOut(0);
        $('.customer-login-form').fadeIn(0);
    });
});

$(document).on('click', '.search-bar-close', function () {
    $('body').removeClass('search-bar-focused');
    $('body').removeClass('search-bar-open');
    $('#search-query').blur();
    if ($(window).width() < 991) {
        $('#MainContent').css('display', 'block');
    }
});




// Remember to call yotpoReviewsFormatting() at the appropriate time,
// e.g., after the DOM is fully loaded, or after the Yotpo reviews have been loaded onto the page.



if ($('body').hasClass('template-page-reviews')) {
    /*
    * arrive.js
    * v2.4.1
    * https://github.com/uzairfarooq/arrive
    * MIT licensed
    *
    * Copyright (c) 2014-2017 Uzair Farooq
    */
    var Arrive=function(e,t,n){"use strict";function r(e,t,n){l.addMethod(t,n,e.unbindEvent),l.addMethod(t,n,e.unbindEventWithSelectorOrCallback),l.addMethod(t,n,e.unbindEventWithSelectorAndCallback)}function i(e){e.arrive=f.bindEvent,r(f,e,"unbindArrive"),e.leave=d.bindEvent,r(d,e,"unbindLeave")}if(e.MutationObserver&&"undefined"!=typeof HTMLElement){var o=0,l=function(){var t=HTMLElement.prototype.matches||HTMLElement.prototype.webkitMatchesSelector||HTMLElement.prototype.mozMatchesSelector||HTMLElement.prototype.msMatchesSelector;return{matchesSelector:function(e,n){return e instanceof HTMLElement&&t.call(e,n)},addMethod:function(e,t,r){var i=e[t];e[t]=function(){return r.length==arguments.length?r.apply(this,arguments):"function"==typeof i?i.apply(this,arguments):n}},callCallbacks:function(e,t){t&&t.options.onceOnly&&1==t.firedElems.length&&(e=[e[0]]);for(var n,r=0;n=e[r];r++)n&&n.callback&&n.callback.call(n.elem,n.elem);t&&t.options.onceOnly&&1==t.firedElems.length&&t.me.unbindEventWithSelectorAndCallback.call(t.target,t.selector,t.callback)},checkChildNodesRecursively:function(e,t,n,r){for(var i,o=0;i=e[o];o++)n(i,t,r)&&r.push({callback:t.callback,elem:i}),i.childNodes.length>0&&l.checkChildNodesRecursively(i.childNodes,t,n,r)},mergeArrays:function(e,t){var n,r={};for(n in e)e.hasOwnProperty(n)&&(r[n]=e[n]);for(n in t)t.hasOwnProperty(n)&&(r[n]=t[n]);return r},toElementsArray:function(t){return n===t||"number"==typeof t.length&&t!==e||(t=[t]),t}}}(),c=function(){var e=function(){this._eventsBucket=[],this._beforeAdding=null,this._beforeRemoving=null};return e.prototype.addEvent=function(e,t,n,r){var i={target:e,selector:t,options:n,callback:r,firedElems:[]};return this._beforeAdding&&this._beforeAdding(i),this._eventsBucket.push(i),i},e.prototype.removeEvent=function(e){for(var t,n=this._eventsBucket.length-1;t=this._eventsBucket[n];n--)if(e(t)){this._beforeRemoving&&this._beforeRemoving(t);var r=this._eventsBucket.splice(n,1);r&&r.length&&(r[0].callback=null)}},e.prototype.beforeAdding=function(e){this._beforeAdding=e},e.prototype.beforeRemoving=function(e){this._beforeRemoving=e},e}(),a=function(t,r){var i=new c,o=this,a={fireOnAttributesModification:!1};return i.beforeAdding(function(n){var i,l=n.target;(l===e.document||l===e)&&(l=document.getElementsByTagName("html")[0]),i=new MutationObserver(function(e){r.call(this,e,n)});var c=t(n.options);i.observe(l,c),n.observer=i,n.me=o}),i.beforeRemoving(function(e){e.observer.disconnect()}),this.bindEvent=function(e,t,n){t=l.mergeArrays(a,t);for(var r=l.toElementsArray(this),o=0;o<r.length;o++)i.addEvent(r[o],e,t,n)},this.unbindEvent=function(){var e=l.toElementsArray(this);i.removeEvent(function(t){for(var r=0;r<e.length;r++)if(this===n||t.target===e[r])return!0;return!1})},this.unbindEventWithSelectorOrCallback=function(e){var t,r=l.toElementsArray(this),o=e;t="function"==typeof e?function(e){for(var t=0;t<r.length;t++)if((this===n||e.target===r[t])&&e.callback===o)return!0;return!1}:function(t){for(var i=0;i<r.length;i++)if((this===n||t.target===r[i])&&t.selector===e)return!0;return!1},i.removeEvent(t)},this.unbindEventWithSelectorAndCallback=function(e,t){var r=l.toElementsArray(this);i.removeEvent(function(i){for(var o=0;o<r.length;o++)if((this===n||i.target===r[o])&&i.selector===e&&i.callback===t)return!0;return!1})},this},s=function(){function e(e){var t={attributes:!1,childList:!0,subtree:!0};return e.fireOnAttributesModification&&(t.attributes=!0),t}function t(e,t){e.forEach(function(e){var n=e.addedNodes,i=e.target,o=[];null!==n&&n.length>0?l.checkChildNodesRecursively(n,t,r,o):"attributes"===e.type&&r(i,t,o)&&o.push({callback:t.callback,elem:i}),l.callCallbacks(o,t)})}function r(e,t){return l.matchesSelector(e,t.selector)&&(e._id===n&&(e._id=o++),-1==t.firedElems.indexOf(e._id))?(t.firedElems.push(e._id),!0):!1}var i={fireOnAttributesModification:!1,onceOnly:!1,existing:!1};f=new a(e,t);var c=f.bindEvent;return f.bindEvent=function(e,t,r){n===r?(r=t,t=i):t=l.mergeArrays(i,t);var o=l.toElementsArray(this);if(t.existing){for(var a=[],s=0;s<o.length;s++)for(var u=o[s].querySelectorAll(e),f=0;f<u.length;f++)a.push({callback:r,elem:u[f]});if(t.onceOnly&&a.length)return r.call(a[0].elem,a[0].elem);setTimeout(l.callCallbacks,1,a)}c.call(this,e,t,r)},f},u=function(){function e(){var e={childList:!0,subtree:!0};return e}function t(e,t){e.forEach(function(e){var n=e.removedNodes,i=[];null!==n&&n.length>0&&l.checkChildNodesRecursively(n,t,r,i),l.callCallbacks(i,t)})}function r(e,t){return l.matchesSelector(e,t.selector)}var i={};d=new a(e,t);var o=d.bindEvent;return d.bindEvent=function(e,t,r){n===r?(r=t,t=i):t=l.mergeArrays(i,t),o.call(this,e,t,r)},d},f=new s,d=new u;t&&i(t.fn),i(HTMLElement.prototype),i(NodeList.prototype),i(HTMLCollection.prototype),i(HTMLDocument.prototype),i(Window.prototype);var h={};return r(f,h,"unbindAllArrive"),r(d,h,"unbindAllLeave"),h}}(window,"undefined"==typeof jQuery?null:jQuery,void 0);

    function yotpoReviewsFormatting() {
        console.log('Review formatting');
        let no_reviews = $('.yotpo-widget-instance .yotpo-empty-state');

        if (no_reviews.length) {
            $('body').addClass('no-reviews');
            $('.accordion-wrapper-reviews').prepend(
                '<span class="absolute-review-link"></span>',
            );
            $('.heading-reviews .accordion__title').html(
                'Be the first to <span class="write-a-review">Write a Review</span>',
            );

            console.log('no reviews');
        } else {
            console.log('has reviews');
            $('body').removeClass('no-reviews');
            $('.accordion-wrapper-reviews .absolute-review-link').remove();

            $('.yotpo-review:not(.branded-review)').each(function () {
                var $this = $(this);

                console.log('Each review');

                let review = {
                    left_panel: $this.find('.yotpo-review-left-panel'),
                    center_panel: $this.find('.yotpo-review-center-panel'),
                    right_panel: $this.find('.yotpo-review-right-panel'),
                    review_details: $this.find('.yotpo-review-details'),
                    review_content: $this.find('.yotpo-review-content'),
                    stars: $this.find('.yotpo-star-rating'),
                    date: $this.find('.yotpo-review-date'),
                    additional_questions: $this.find(
                        '.yotpo-review-customer-questions-container',
                    ),
                    reviewer: $this.find('.yotpo-reviewer'),
                    reviewer_name: $this.find('.yotpo-reviewer-name'),
                    read_more: $this.find('.yotpo-read-more'),
                    see_more: $this.find('.yotpo-custom-questions-see-more-label'),
                    location: null, // Initialize location as null; it will be updated if a location is found
                };

                if (review.see_more.length) {
                    review.see_more.click();
                    review.see_more.remove();
                }

                if (review.read_more.length) {
                    review.read_more[0].click();
                    //review.read_more.remove();
                }

                // Trigger see more click to potentially reveal more content

                // Reformat the date text
                var newDateText = review.date.find('div').text().replace(/\//g, '.');
                review.date.find('div').text(newDateText);

                // Split the date string into components assuming it's in the format dd.mm.yy
                var dateParts = newDateText.split('.');
                // Check if the dateParts array has the expected 3 parts (day, month, year)
                if (dateParts.length === 3) {
                    // Reassemble the date in the format mm.dd.yy
                    var formattedDate = dateParts[1] + '.' + dateParts[0] + '.' + dateParts[2];
                    // Update the text with the new format
                    review.date.find('div').text(formattedDate);
                } else {
                    console.error('Unexpected date format:', newDateText);
                }
                if ($(window).width() < 991) {
                    // Mobile-specific adjustments
                    const $reviewsSearchInput = $('#searchInput');
                    let writeAReviewButton = $('.yotpo-new-review-btn-wrapper');

                    $reviewsSearchInput.attr('placeholder', 'Search');

                    $('.yotpo-filters-container-inner').append(writeAReviewButton);
                    review.reviewer.append(review.date);
                    review.review_content.append(review.reviewer);
                } else {
                    // Desktop-specific adjustments
                    $this.find('.yotpo-review-left-panel').prepend(review.stars);
                    $this.find('.yotpo-review-left-panel').append(review.date);
                    $this.find('.yotpo-review-center-panel').append(review.additional_questions);
                }
                $this.addClass('branded-review');
            });
        }
        setTimeout(function () {
            if ($('.initial-review-load').length) {
                $('.initial-review-load').removeClass('initial-review-load');
            }
        }, 200);
    }

    document.arrive(
        '.yotpo-widget-instance[data-yotpo-instance-id="616163"] .yotpo-reviews-seo-pagination-item',
        function () {
            yotpoReviewsFormatting();
            // Your existing mutation observer...
            const reviewsDisplayEl = $(
                '.yotpo-widget-instance[data-yotpo-instance-id="616163"]',
            )[0];
            const reviewsObserverconfig = { attributes: false, childList: true, subtree: true };
            const reviewsPageChange = (mutationsList, reviewsPageChange) => {
                for (let mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        yotpoReviewsFormatting();
                        setTimeout(setAccordionHeight, 100);
                        reviewsPageChangeObserver.disconnect();
                    }
                }
            };
            let reviewsPageChangeObserver = new MutationObserver(reviewsPageChange);
            // 'this' refers to the newly created element
            $(this).on('click', function () {
                console.log('clicked page number');
                reviewsPageChangeObserver.observe(reviewsDisplayEl, reviewsObserverconfig);
            });
        },
    );

    document.arrive(
        '.yotpo-widget-instance[data-yotpo-instance-id="616163"] .yotpo-reviews-seo-pagination-item',
        function () {
            // Your existing mutation observer...
            const reviewsDisplayEl = $(
                '.yotpo-widget-instance[data-yotpo-instance-id="616163"]',
            )[0];
            const reviewsObserverconfig = { attributes: false, childList: true, subtree: true };
            const reviewsPageChange = (mutationsList, reviewsPageChange) => {
                for (let mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        yotpoReviewsFormatting();
                        setTimeout(setAccordionHeight, 100);
                        reviewsPageChangeObserver.disconnect();
                    }
                }
            };
            let reviewsPageChangeObserver = new MutationObserver(reviewsPageChange);
            // 'this' refers to the newly created element
            $('.ugc-storefront-widgets-tabs-container__tab').on('click', function () {
                console.log('clicked page number');
                reviewsPageChangeObserver.observe(reviewsDisplayEl, reviewsObserverconfig);
            });
        },
    );

    var currentObserver = null;
    const reviewObserver = function (element, updateReviewLayout) {
        // If there's an existing observer, disconnect it before creating a new one
        if (currentObserver) {
            currentObserver.disconnect();
            //console.log('Previous mutation observer disconnected');
        }
        // Options for the observer
        var config = { attributes: false, childList: true, subtree: true };
        // Callback function to execute when mutations are observed
        var callback = function (mutationsList, observer) {
            // Clear the timeout as soon as a mutation is detected
            clearTimeout(timeoutID);
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    // If children are added or removed, set the height
                    setAccordionHeight();
                    yotpoReviewsFormatting();
                    //console.log('Mutation observer fired');
                    // Disconnect observer after the first change
                    observer.disconnect();
                    // Clear current observer
                    currentObserver = null;
                }
            }
        };
        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);
        // Set current observer to this new observer
        currentObserver = observer;
        // Start observing the target node for configured mutations
        observer.observe(element, config);
        // Setup a timeout to disconnect observer after 1 second
        var timeoutID = setTimeout(function () {
            observer.disconnect();
            //console.log('Mutation observer disconnected due to timeout');
            // Clear current observer
            currentObserver = null;
        }, 1000);
    };

    $(document).on('click', '.yotpo-clear-filters, .yotpo-dropdown-option', function () {
        reviewObserver(
            $('.yotpo-widget-instance[data-yotpo-instance-id="616163"] #yotpo-app')[0],
            yotpoReviewsFormatting,
        );
    });
    $(document).on('keydown', '.yotpo-search-input', function (e) {
        var key = e.which || e.keyCode;
        if (key === 13) {
            // 13 is the code for the Enter key
            // prevent form submission if the input is within a form
            reviewObserver(
                $('.yotpo-widget-instance[data-yotpo-instance-id="616163"] #yotpo-app')[0],
                yotpoReviewsFormatting,
            );
        }
    });

    document.addEventListener(
        'animationstart',
        function (event) {
            if (event.animationName == 'yotpoNodeInserted') {
                console.log('widget loaded');
                if ($(window).width() < 991) {
                    $('.reviews-wrapper .yotpo-widget-instance').appendTo(
                        '.accordion-reviews .accordion__content-inner',
                    );
                } else {
                    const reviewsSearchInput = $('#searchInput');
                    let reviewsRating = $('.yotpo-header-container .yotpo-bottom-line-score');

                    reviewsSearchInput.attr('placeholder', 'Search');

                    $('.yotpo-bottom-line-stars').append(reviewsRating);
                }

                yotpoReviewsFormatting();
            }
        },
        true,
    );
}
